module.exports = __webpack_public_path__ + "static/media/la police_crop-alt.6a3ec7cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/la police_crop-alt.jpg
// module id = 454
// module chunks = 0